import {
  TranslatableDict,
  TranslatableField,
} from '@/models/TranslatableField';

export const normalizeTranslatableField = (
  value?: TranslatableField | null,
): TranslatableDict => {
  if (!value) return { en: '', 'pt-br': '' };
  if (typeof value === 'string') return { en: value, 'pt-br': value };
  return { en: value.en ?? '', 'pt-br': value['pt-br'] ?? '' };
};
